import { containsTemplateVariables } from '@packages/shared-ui/utils';
import dynamic from 'next/dynamic';
import type React from 'react';
import type { UniversalEmbedCF } from '@/types';
import ServerEmbed from './Embed/Server';
import useStyles from './UniversalEmbed.styles';

const ClientEmbed = dynamic(import('./Embed/Client'), { ssr: false });

interface UniversalEmbedProps {
  content: UniversalEmbedCF;
}

const UniversalEmbed: React.FC<UniversalEmbedProps> = ({ content }) => {
  const { snippet, ...styles } = content.fields;
  const { classes, cx } = useStyles(styles);
  if (!snippet) return null;

  // embeds with variables should be rendered in browser context only
  const containsVariables = containsTemplateVariables(snippet);

  return (
    <div className={cx(classes.container)}>
      <div className={classes.embedWrapper}>
        {!containsVariables && <ServerEmbed snippet={snippet} />}
        {containsVariables && <ClientEmbed snippet={snippet} />}
      </div>
    </div>
  );
};

export default UniversalEmbed;
